const MB = 1024 * 1024;
export const MAX_PRODUCT_INPUT = 20 * MB;
export const MAX_PRODUCT_UPLOAD = 8 * MB;

// Optimize the upload copy only. Never chase a byte target by degrading quality.
export async function prepareProductImage(file) {
  if (!file?.size) throw new Error('File foto kosong. Pilih foto lain.');
  if (file.size > MAX_PRODUCT_INPUT) throw new Error('File foto maksimal 20 MB.');
  if (file.type ? !/^image\/(jpeg|png|webp)$/i.test(file.type) : !/\.(jpe?g|png|webp)$/i.test(file.name)) {
    throw new Error('Gunakan foto JPG, PNG, atau WebP.');
  }
  let source, image, canvas;
  try {
    source = URL.createObjectURL(file);
    image = new Image();
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = () => reject(new Error('Foto tidak dapat dibaca. Pilih foto JPG, PNG, atau WebP lain.'));
      image.src = source;
    });
    const width = image.naturalWidth, height = image.naturalHeight;
    if (!width || !height || width * height > 40000000) throw new Error('Resolusi foto maksimal 40 megapiksel.');
    const scale = Math.min(1, 1200 / Math.max(width, height));
    // Server validates orientation/dimensions and keeps compliant files unchanged.
    if (scale === 1 && (file.size <= 250 * 1024 || (file.type === 'image/webp' && file.size <= MAX_PRODUCT_UPLOAD))) return file;
    canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Browser tidak dapat memproses foto. Coba muat ulang.');
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = 'high';
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/webp', 0.85));
    if (!blob?.size) throw new Error('Foto gagal dikompres. Pilih foto lain.');
    if (scale === 1 && blob.size >= file.size && file.size <= MAX_PRODUCT_UPLOAD) return file;
    if (blob.size > MAX_PRODUCT_UPLOAD) throw new Error('Foto masih terlalu besar. Pilih foto lain; kualitas tidak diturunkan paksa.');
    const extension = blob.type === 'image/webp' ? 'webp' : 'png';
    return new File([blob], `produk.${extension}`, { type: blob.type });
  } finally {
    if (source) URL.revokeObjectURL(source);
    if (image) { image.onload = null; image.onerror = null; image.src = ''; }
    if (canvas) { canvas.width = 0; canvas.height = 0; }
  }
}
